<div class="w-full h-screen relative flex items-center justify-center bg-gray-100" dir="rtl" *ngIf="Vislogin">
  <!-- بک‌گراند تصویر مات -->
  <div class="absolute inset-0 bg-cover bg-center filter blur-lg brightness-75"
       style="background-image:url('/assets/img/demo/76.png');">
  </div>

  <!-- کارت لاگین -->
  <div class="relative w-full max-w-md p-8 bg-white/20 backdrop-blur-lg rounded-2xl shadow-xl flex flex-col gap-6 transition-all duration-500 hover:scale-105">
    
    <!-- لوگو و عنوان -->
    <div class="flex flex-col items-center justify-center">
      <img class="mb-4" style="width: 10rem;"src="/assets/img/demo/Logo.png">
      <h2 class="text-3xl font-bold text-[rgb(35,43,62)] text-center drop-shadow-md">خوش آمدید</h2>
      <h4 class="text-center text-[rgb(35,43,62)]/80 mt-1">با شماره تلفن خود وارد شوید.</h4>
    </div>

    <!-- فرم لاگین -->
    <form [formGroup]="form" class="flex flex-col gap-4">

      <!-- ایمیل -->
      <input  formControlName="phoneNumber" type="phoneNumber" placeholder="شماره همراه" pattern="[0-9]*"
      (input)="allowOnlyNumbers($event)" (keydown.space)="send()" (keydown.enter)="send()"
       class="w-full p-3 rounded-xl border border-gray-300 bg-white/20 placeholder-[rgb(35,43,62)]/60 focus:outline-none focus:ring-2 focus:ring-[rgb(255,87,34)] focus:border-transparent transition shadow-sm text-[rgb(35,43,62)]">

      <!-- پسورد -->


      <!-- گزینه‌ها -->
      <!-- <div class="flex items-center justify-between text-sm text-[rgb(35,43,62)]">
        <mat-checkbox color="primary" class="text-[rgb(35,43,62)]">مرابه خاطر بسپار</mat-checkbox>
        <a [routerLink]="['/forgot-password']" class="hover:underline text-[rgb(255,87,34)]">فراموشی رمز عبور</a>
      </div> -->

      <!-- دکمه ورود -->
      <button (click)="send()" type="button"
      [disabled]="loading"
      class="w-full py-3 bg-[rgb(255,87,34)] text-white rounded-xl font-semibold shadow-md">
    
      <span *ngIf="!loading">ورود</span>
      <span *ngIf="loading">در حال ارسال...</span>
    
    </button>
    

      <!-- ثبت‌نام -->
      <p class="text-center text-[rgb(35,43,62)] text-sm">
    با فرمت ********09 وارد شوید<br/>
        <!-- <a [routerLink]="['/register']" class="text-[rgb(255,87,34)] hover:underline">ایجاد حساب کاربری</a> -->
      </p>
    </form>
  </div>
</div>
<div class="w-full h-screen relative flex items-center justify-center bg-gray-100" dir="rtl" *ngIf="VisCod">
  <!-- بک‌گراند تصویر مات (همسان با دیگر صفحات) -->
  <div class="absolute inset-0 bg-cover bg-center filter blur-lg brightness-75"
       style="background-image: url('/assets/img/demo/76.png');">
  </div>

  <!-- کارت بازنشانی رمز عبور -->
  <div class="relative w-full max-w-md p-8 bg-white/20 backdrop-blur-lg rounded-2xl shadow-xl flex flex-col gap-6 transition-all duration-500 hover:scale-105">
    
    <!-- لوگو و عنوان -->
    <div class="flex flex-col items-center justify-center">
      <img class="mb-4" style="width: 8rem;" src="/assets/img/demo/Logo.png">
      <h2 class="text-3xl font-bold text-[rgb(35,43,62)] text-center drop-shadow-md">  وارد کردن رمز یکبار مصرف</h2>
      <h4 class="text-center text-[rgb(35,43,62)]/80 mt-1">
        رمز یکبار مصرف ارسال شده به شماره 
        <span class="font-semibold">
          {{ form.get('phoneNumber').value }}
        </span>
        را وارد کنید
      </h4>    </div>
      <button type="button"
      (click)="editPhone()"
      class="text-sm text-[rgb(255,87,34)] hover:underline text-center">
      ویرایش شماره
      </button>
    <!-- فرم بازنشانی رمز عبور -->
    <form [formGroup]="form1" class="flex flex-col gap-6">

      <div class="flex justify-center gap-3" dir="ltr">
        <input maxlength="1" formControlName="d1" (keydown.space)="verifyCode()"  (keydown.enter)="verifyCode()"
          (input)="moveNext($event, 'd2')"  pattern="[0-9]*"
          class="otp-input" />
    
        <input maxlength="1" formControlName="d2" (keydown.space)="verifyCode()"  (keydown.enter)="verifyCode()"
          (input)="moveNext($event, 'd3')"  pattern="[0-9]*"
          class="otp-input" />
    
        <input maxlength="1" formControlName="d3" (keydown.space)="verifyCode()"  (keydown.enter)="verifyCode()"
          (input)="moveNext($event, 'd4')"  pattern="[0-9]*"
          class="otp-input" />
    
        <input maxlength="1" formControlName="d4"   pattern="[0-9]*" (keydown.space)="verifyCode()"  (keydown.enter)="verifyCode()"
          class="otp-input" />
      </div>
    
      <button (click)="verifyCode()" type="button"
        class="w-full py-3 bg-[rgb(255,87,34)] hover:bg-[rgb(230,70,25)] text-white rounded-xl font-semibold shadow-md transition-all duration-300">
        تایید کد
      </button>
      <div class="text-center text-sm mt-4">

        <span *ngIf="!canResend">
          ارسال مجدد تا {{countdown}} ثانیه دیگر
        </span>
      
        <button *ngIf="canResend"
                (click)="resendCode()"
                class="text-[rgb(255,87,34)] hover:underline font-semibold">
          ارسال مجدد کد
        </button>
      
      </div>
      
    </form>
    
  </div>
</div>